import { useEffect } from "react";

// This app has no per-route title library (no react-helmet), and
// public/index.html serves one static <title>/<meta name="description">
// for every route. This hook lets a single page override them while it's
// mounted, restoring the site-wide defaults on unmount so other routes
// aren't left with a stale title after client-side navigation.
export function usePageMeta({ title, description, enabled = true }) {
  useEffect(() => {
    if (!enabled) return undefined;

    const previousTitle = document.title;
    const descriptionEl = document.querySelector('meta[name="description"]');
    const previousDescription = descriptionEl
      ? descriptionEl.getAttribute("content")
      : null;

    document.title = title;
    if (descriptionEl) {
      descriptionEl.setAttribute("content", description);
    }

    return () => {
      document.title = previousTitle;
      if (descriptionEl && previousDescription !== null) {
        descriptionEl.setAttribute("content", previousDescription);
      }
    };
  }, [title, description, enabled]);
}
